export default class CreateWorkTypeError extends Error {

}